export function resolveAssignmentInstanceLabel(
  assignment,
  {
    baseName = 'Assignment',
    sameTypeCount = 1,
    alwaysNumber = false
  } = {}
) {
  const customName =
    String(
      assignment?.instance_name ||
      ''
    ).trim();

  if (customName) {
    return customName;
  }

  const cleanBaseName =
    String(
      baseName ||
      ''
    ).trim() ||
    'Assignment';

  const instanceNumber =
    assignment?.instance_number;

  if (
    (
      alwaysNumber ||
      Number(sameTypeCount) > 1
    ) &&
    instanceNumber !== null &&
    instanceNumber !== undefined &&
    String(instanceNumber).trim() !== ''
  ) {
    return (
      cleanBaseName +
      ' ' +
      instanceNumber
    );
  }

  return cleanBaseName;
}
